import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
  useRef
} from 'react';
import { Button, RadioGroup } from 'devextreme-react';
import { LoadPanel } from 'devextreme-react/load-panel';
import ScrollView from 'devextreme-react/scroll-view';
import { formatMessage } from 'devextreme/localization';
import Layout from '../../containers/Layout';
import style from './sectionStock.module.scss';
import PopupErrorMVP from '../../components/PopupErrorMVP';
import SearchBar from '../../components/SearchBar/SearchBar';

const SelectionStock = ({
  history,
  stockReducer: {
    listStocks,
    error,
    loading
  },
  userReducer: {
    id,
    // userInfo,
    userInfoError,
    userInfoStatus,
    logoutLoading,
    logout
  },
  fetchStock,
  userLogoutRequest
}) => {
  const scrollRef = useRef(null);
  const [buttonActive, setButtonActive] = useState(true);
  const [valueChanged, setValueChanged] = useState(null);
  // const [topScroll, setTopScroll] = useState(2);
  const [inputValue, setInputValue] = useState('');
  const [filterListStocks, setFilterListStocks] = useState(null);
  const [plantIdCleared, setPlantIdCleared] = useState(false);

  useEffect(() => {
    if (!plantIdCleared) {
      localStorage.setItem('plantId', '-1');
      setPlantIdCleared(true);
    }
  }, [plantIdCleared]);

  useEffect(() => {
    if (listStocks.length && !logoutLoading) {
      setTimeout(() => {
        try {
          scrollRef.current.instance.update();
        } catch (e) {
          console.debug('ERROR scrollRef.current.instance.update()', e);
        }
      }, 1000);
    }
  }, [listStocks.length, listStocks, logoutLoading]);

  useEffect(() => {
    if (id !== null) {
      fetchStock({ id });
    }
    if (userInfoError === ''
      || userInfoStatus === 401
      || userInfoStatus === 403) {
      history.push('/');
    }
  }, [fetchStock, id, userInfoError, history, userInfoStatus]);

  useEffect(() => {
    if (listStocks.length === 1) {
      history.push(`/tablist/${listStocks[0].plantId}`);
    }
  }, [listStocks, history]);

  useEffect(() => {
    if (logout) {
      window.localStorage.removeItem('userInfo');
      // document.execCommand('ClearAuthenticationCache'); // ie 11
      document.location.href = '/';
    }
  }, [logout, history]);

  // useEffect(() => {
  //   if (userInfo === false) {
  //     history.push('/');
  //   }
  // }, [userInfo, history]);

  useEffect(() => {
    const regex = new RegExp(/#?[^$\\/%@&?><[\]*+:;,.]/);
    if (regex.test(inputValue) || inputValue === '') {
      setFilterListStocks(listStocks.filter((item) =>
        item.plantShortDescr.toUpperCase().includes(inputValue.toUpperCase())));
    } else {
      setInputValue('');
    }
  }, [listStocks, inputValue]);

  const changedValue = useCallback((e) => {
    setValueChanged(e.value);
    setButtonActive(false);
  }, []);

  const buttonOnClick = useCallback(() => {
    localStorage.setItem('plantId', valueChanged.plantId);
    history.push(`/tablist/${valueChanged.plantId}`);
  }, [history, valueChanged]);

  const renderRadioGroup = useMemo(() => (data) => data.plantShortDescr, []);

  const listStock = useMemo(() => (
    <div className={style.containing}>
      <div>
        <LoadPanel shadingColor={'rgba(0,0,0,0.4)'}
                   showPane
                   shading={false}
                   showIndicator
                   visible={loading}
        />
        <h3 className={style.h3}>{formatMessage('textSelectStock')}</h3>
        <SearchBar style={{}}
                   inputValue={inputValue}
                   setInputValue={(value) => {
                     const regex = new RegExp(/#?[^\\/$%@&?><[\]*+:;,.]/);
                     if (regex.test(value) || value === '') {
                       setInputValue(value);
                     } else {
                       setInputValue(value.substr(0, value.length - 1));
                     }
                   }}
                   buttonSearchVisible={false}
                   placeholder={formatMessage('searchBar').placeholderPlant}
                   noPadding
         />
        <ScrollView elementAttr={{ class: style.itemScroll }}
                    showScrollbar="always"
                    ref={scrollRef}
                    // onScroll={({ scrollOffset }) => {
                    //   setTopScroll(scrollOffset.top);
                    // }}
                    // onInitialized={({ component }) => {
                    //   setTimeout(() => {
                    //     try {
                    //       console.debug(component);
                    //       component.refresh();
                    //     } catch (e) { }
                    //   }, 1000);
                    // }}
                    // height={370}
        >
          <RadioGroup elementAttr={{ class: style.itemRadioButton }}
                      items={(filterListStocks && filterListStocks.length)
                        ? filterListStocks
                        : listStocks}
                      itemRender={renderRadioGroup}
                      onOptionChanged={changedValue}
                      value={valueChanged} />
        </ScrollView>
        <Button text={formatMessage('textContinue')}
                type="default"
                elementAttr={{ class: style.button }}
                disabled={buttonActive}
                onClick={buttonOnClick}
        />
      </div>
    </div>
  ), [
    buttonActive,
    buttonOnClick,
    changedValue,
    listStocks,
    filterListStocks,
    loading,
    renderRadioGroup,
    // topScroll,
    valueChanged,
    inputValue

  ]);

  const getOnHiding = useCallback(() => {
    window.localStorage.removeItem('userInfo');
    userLogoutRequest();
    setTimeout(() => {
      document.location.href = `${document.location.origin}`;
    }, 1000);
  }, [userLogoutRequest]);

  return (
    <Layout>
      { listStock }
      <PopupErrorMVP visible={!!userInfoError
        && !logoutLoading
        && userInfoStatus
        && userInfoStatus !== 401
        && userInfoStatus !== 403}
                     message={(!userInfoError?.message)
                       ? (userInfoStatus === 500)
                         ? formatMessage('textError').endSession
                         : (userInfoStatus === 503)
                           ? formatMessage('textError').serviceUnavailable
                           : formatMessage('textError').unknownError
                       : userInfoError?.message}
                     techInfo={(!userInfoError?.techInfo)
                       ? `${formatMessage('textSupportPhone')} 8-800-200-69-39`
                       : userInfoError?.techInfo}
                     onHiding={getOnHiding}
                     width={'600'}
                     types="info"
      />
      <PopupErrorMVP visible={!!error && !logoutLoading}
                     message={error.message}
                     onHiding={getOnHiding}
                     width={'600'}
                     types="info"
      />
      <LoadPanel shadingColor={'rgba(0,0,0,0.4)'}
                 showPane
                 shading={false}
                 showIndicator
                 visible={logoutLoading}
      />
    </Layout>
  );
};

export default SelectionStock;
